export const appVars = {
  ApiBaseUrl: import.meta.env.VITE_CC_API_URL,
  ApiVersion: import.meta.env.VITE_CC_API_VERSION,
  BBApiPrefix: import.meta.env.VITE_CC_API_BB_PREFIX,
  BBApiBaseUrl: import.meta.env.VITE_API_LOCATION,
  IsMockDataEnabled: import.meta.env.VITE_MOCK_DATA === "true",
  isProduction: import.meta.env.VITE_PERM_ENV !== "production",
};
